import {intersection, union, difference, map} from 'lodash-es';

export const getprefixes = function(arr = []) {
  return arr.reduce((prefixes, item) => {
    const dotidx = item.lastIndexOf('.');

    if (dotidx > 0) {
      prefixes.push(item.substring(0, dotidx));
    }

    return prefixes;
  }, []);
};

// collect the permissions required by the given state, up to root state
export const collectPermissions = function(state) {
  let permissions = [];
  let prefixes = [];

  //load permissions from the init (given) state
  if (state.requiredFeatures) {
    permissions = [...permissions, ...state.requiredFeatures];
    prefixes = [...prefixes, ...getprefixes(state.requiredFeatures)];
  }

  let parentState = state.parent;

  // Merge required permissions from all parent states up to the root
  while (parentState) {
    if (parentState.requiredFeatures) {
      const inheritedPermissions = intersection(prefixes, parentState.requiredFeatures);

      if (inheritedPermissions.length) {
        permissions = [...permissions, ...inheritedPermissions];
        prefixes = union(prefixes, getprefixes(inheritedPermissions));
      }
    }

    parentState = parentState.parent;
  }

  return permissions;
};

export const isStateAuthorized = (state, currentUser) => {
  if (!currentUser || !currentUser.features) {
    return false;
  }

  if (!state) {
    return false; //there was an error with the decorator for ui router
  }

  if (state.requiresChangeEmail) {
    if (!currentUser.changeEmail) {
      return false;
    }
  }

  if (state.requiredAdminRole) {
    if (
      currentUser.roles &&
      currentUser.roles.data &&
      currentUser.roles.data.filter(role => '' + role.id === '-1').length === 0
    ) {
      return false;
    }
  }

  // collect the features required by the current state
  // ensure the user has all of them
  const requiredPermissions = collectPermissions(state);

  if (requiredPermissions.length) {
    const permissions = map(currentUser.features, f => f.path);
    if (difference(requiredPermissions, permissions).length > 0) {
      return false;
    }
  }

  // filter by data points
  if (state.requiredDatapoints) {
    const userDatapoints = map(currentUser.visibleDatapoints || [], dp => dp.id);
    if (difference(state.requiredDatapoints, userDatapoints).length > 0) {
      return false;
    }
  }
  return true;
};
